import React from 'react';
import UserDropdownBox from './UserDropdownBox';
import {logout} from '../../client/helpers/AuthHelper';
import {changeStateMenuClosed} from '../../client/helpers/LeftMenuHelper';
import {handleClickShowTopMenuDropdown} from '../../client/helpers/TopMenuHelper';
import {Link} from 'react-router-dom';

const Header = () => {
    return(
    <header className="topbar">
        <nav className="navbar top-navbar navbar-expand-md navbar-light">
            <div className="navbar-header">
                <Link className="navbar-brand" to="/">
                    <img src={"/images/garrett-advancing-motion.png"} alt="homepage" className="logo" />
                </Link>
            </div>
            <div className="navbar-collapse">
                <ul className="navbar-nav mr-auto mt-md-0 header-navbar-menu-search">
                    <li className="nav-item mr-2">
                        <button className="nav-link sidebartoggler d-md-block text-muted waves-effect waves-dark"
                            type="button" onClick={changeStateMenuClosed}>
                            <i className="fas fa-bars"></i>
                        </button>
                    </li>
                    <li className="nav-item d-md-block search-box">
                        <Link className="nav-link d-md-block text-muted waves-effect waves-dark" to="/">
                            <i className="fas fa-search"></i>
                        </Link>
                        <form className="app-search">
                            <input type="text" className="form-control" placeholder="Search & enter" />
                            <Link className="srh-btn" to="/">
                                <i className="ti-close"></i>
                            </Link>
                        </form>
                    </li>
                </ul>  
                <ul className="navbar-nav my-lg-0">
                    <li className="nav-item dropdown">
                        <button type="button" onClick={handleClickShowTopMenuDropdown} className="nav-link dropdown-toggle text-muted waves-effect waves-dark profile-pic-link"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="top-menu-dropdown-toggle">
                            <img src={"/images/image.png"} alt="user" className="profile-pic" />
                            Radoslav Rychvalsky
                        </button>
                        <UserDropdownBox />
                    </li>
                    <li className="nav-item ml-4">
                        <button className="nav-link dropdown-toggle text-muted waves-effect waves-dark" onClick={logout}
                            type="button">
                            <i className="fas fa-power-off"></i>
                        </button>
                    </li>
                </ul>
            </div>
        </nav>
    </header>
    )
}

export default Header;
